import { getSemanticPropsByNumber } from '@ui/utils/getSemanticProps';
import { forwardRef, Ref, useMemo } from 'react';

import { Amount, AmountProps } from './Amount';

type Props = AmountProps & {
  hasColor?: boolean;
};

const AmountChangeComponent = (
  { value, hasColor, opts, ...props }: Props,
  ref: Ref<HTMLParagraphElement>,
) => {
  const { color } = useMemo(() => {
    return getSemanticPropsByNumber(value);
  }, [value]);

  return (
    <Amount
      ref={ref}
      {...props}
      value={value}
      color={hasColor ? color : undefined}
      opts={{
        ...opts,
        isShowSign: true,
      }}
    />
  );
};

export const AmountChange = forwardRef(AmountChangeComponent);
